export interface IWarningBannerProps {
  className?: string;
  children?: React.ReactNode;
}

function WarningBanner({ className, children }: IWarningBannerProps) {
  return (
    <div
      className={`p-2 text-sm rounded-md border border-amber-600 bg-amber-50 gap-2 text-amber-600 w-full text-center ${className}`}>
      {children}
    </div>
  );
}

export default WarningBanner;
